<div fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" style="margin-bottom: 32px">
  <img src="/assets/iconography/agoda.svg" class="agoda-logo" />
  <h2 class="nomargin">Once your Agoda connection is complete:</h2>
</div>

<div style="padding-top: 32px">
  <h3>Enter your Agoda account email</h3>
  <p class="subtitle">This is the email you used to log in to your Agoda account.</p>

  <mat-form-field class="fw" id="search-input">
    <input
      type="search"
      data-intercom-target="agoda-credentials-input"
      [(ngModel)]="email"
      matInput
      type="email"
      autofocus />
    <button mat-button *ngIf="email" matSuffix mat-icon-button aria-label="Clear" (click)="email = ''">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div style="padding-top: 32px">
  <h3>Enter the property IDs or URLs for all connected properties</h3>
  <p class="subtitle">
    <a
      target="_blank"
      href="https://help.hospitable.com/en/articles/11077770-where-to-find-your-agoda-property-id"
      class="link">
      Where to find your Agoda property ID or URL?
    </a>
  </p>

  <form [formGroup]="propertyIdsForm">
    <div
      formArrayName="propertyIds"
      fxLayout
      fxLayoutAlign="space-between center"
      style="margin-bottom: 16px"
      fxLayoutGap="16px"
      *ngFor="let propertyId of propertyIds.controls; let i = index">
      <mat-form-field class="fw nopadding nomargin" [id]="'property-ids-' + i">
        <mat-label>Property ID or URL for Property {{ i + 1 }}</mat-label>
        <input
          [formControlName]="i"
          placeholder="Enter property ID (e.g. 8792186) or URL"
          matInput
          type="text"
          data-intercom-target="agoda-property-input" />
        <button
          mat-button
          *ngIf="i > 0"
          matSuffix
          mat-icon-button
          aria-label="Remove"
          (click)="removePropertyIdField(i)">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </form>

  <sbnb-button
    label="+ Add more"
    [fullWidth]="true"
    size="mini"
    type="secondary"
    (click)="addPropertyIdField()"></sbnb-button>
</div>

<div style="margin-top: 16px" fxLayout fxLayoutGap="10px" fxLayoutAlign="end center">
  <sbnb-button label="Back" type="secondary" (click)="back()"></sbnb-button>
  <sbnb-button
    data-intercom-target="agoda-property-ids-continue"
    label="Continue"
    [disabled]="this.propertyIdsForm.invalid || !email"
    [loading]="loading"
    (click)="progress()"></sbnb-button>
</div>
